import React, { useEffect } from 'react';
import { useLang } from '../context/LangContext';
import LandingChrome from '../components/LandingChrome';
import { FAQ_DATA } from '../data/marketingData';
import './Landing.css';

const DOC_TITLE_EN = 'FAQ - ReplyTek AI WhatsApp Assistant';
const DOC_TITLE_ES = 'Preguntas frecuentes - ReplyTek';

export default function FAQ() {
  const { lang } = useLang();

  useEffect(() => {
    document.title = lang === 'en' ? DOC_TITLE_EN : DOC_TITLE_ES;
  }, [lang]);

  return (
    <LandingChrome>
      <main>
        <section className="section faq" style={{ paddingTop: '6rem' }}>
          <h1 className="section__title">
            {lang === 'en' ? 'Frequently Asked Questions' : 'Preguntas frecuentes'}
          </h1>
          <div className="faq__list faq__list--static">
            {FAQ_DATA.map((item, i) => (
              <article className="faq__item faq__item--open" key={i}>
                <h2 className="faq__question faq__question--static">
                  <span>{item.q[lang]}</span>
                </h2>
                <div className="faq__answer faq__answer--visible">
                  {(item.aExpanded && item.aExpanded[lang]) || item.a[lang]}
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
    </LandingChrome>
  );
}
